import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const GalleryBlock = ({ block }) => {
  const { title, images } = block;
  const [index, setIndex] = useState(-1);

  const slides = images.map((image) => ({
    src: image.url,
    alt: image.alt,
  }));

  return (
    <div className="gallery-block">
      {title && <h3>{title}</h3>}
      <div className="gallery-images">
        {images.map((image, index) => (
          <img
            key={image.url}
            src={image.url}
            alt={image.alt}
            onClick={() => setIndex(index)}
            style={{ cursor: 'zoom-in' }}
          />
        ))}
      </div>
      <Lightbox slides={slides} open={index >= 0} index={index} close={() => setIndex(-1)} />
    </div>
  );
};

export default GalleryBlock;
